import React, {useEffect, useState} from "react";

import {useTranslation} from "react-i18next";
import {usePagination, useSortBy, useTable} from "react-table";
import {Col, CustomInput, Input, Row, Table} from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";

import Aux from "../../../../../hoc/Auxiliary";
import {debounce} from "lodash";
import Spinner from "../../../../UI/Spinner";

const findObject = (obj = {}, query) => {
    for (const [key, value] of Object.entries(obj)) {
        if (typeof value === "string") {
            if (value.toLowerCase().includes(query.toLowerCase())) {
                return true;
            }
        } else if (typeof value === "object" && value !== null) {
            if (findObject(value, query)) {
                return true;
            }
        }
    }
    return false;
};

const SubAccountsTable = ({
                          columns,
                          data,
                          loading,
                          checked
                      }) => {
    const {t} = useTranslation();
    const [searchData, setSearchData] = useState([]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        rows,
        state: {pageIndex, pageSize},
    } = useTable(
        {
            columns,
            data: searchData,
            rows,
            initialState: {
                pageIndex: 0,
                pageSize: 10
            },
            disableSortBy: true,
        },
        useSortBy,
        usePagination
    );

    useEffect(() => data && setSearchData(data), [data]);
    const handleSearch = debounce((query) => {
        if (!query) {
            setSearchData(data);
            return;
        }
        const searchData = data.filter((item) => findObject(item, query));
        setSearchData(searchData);
        return;
    }, 300);

    const onChangeInSelect = (event) => {
        setPageSize(Number(event.target.value));
    };

    const onChangeInInput = (event) => {
        const page = event.target.value ? Number(event.target.value) - 1 : 0;
        gotoPage(page);
    };

    return (
        <Aux>
            <div style={{maxWidth: "935px"}}
                 className="flex flex-column section--padding--bottom--30 section--invoices">

                <div className="search-form flex">
                    <div className="flex flex-grow-1 align-items-center">
                        <input
                            type="text"
                            className="form-control"
                            id="search"
                            aria-label="Search"
                            placeholder={t(`profile.assignments.form.subaccounts.search_placeholder`)}
                            style={{paddingRight:"52px"}}
                            onChange={(v) => handleSearch(v.target.value)}
                        />
                        <i className="far fa-search"></i>
                    </div>
                </div>
            </div>
            <div className="nopadding overflow-auto w-100 flex flex-column">
                <Table
                    hover
                    {...getTableProps()}
                    style={{width:"100%",maxWidth: "935px"}}
                    className="datatable datatable__responsive table-responsive  d-table"
                >
                    <thead
                        className={
                            data.length === 0 || loading
                                ? "flex flex-row justify-content-between w-100"
                                : "flex-row"
                        }
                    >
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps()}>
                                    {column.render("Header")}
                                </th>
                            ))}
                        </tr>
                    ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                        prepareRow(row);
                        return (
                            <Aux key={row.getRowProps().key}>
                                <tr>
                                    {row.cells.map((cell) => {
                                        return (
                                            <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                                        );
                                    })}
                                </tr>
                            </Aux>
                        );
                    })}
                    </tbody>
                </Table>
                {loading ? (
                    <div className="container flex flex-column justify-content-center align-items-center">
                        <Spinner/>
                    </div>
                ) : null}
            </div>

            <div className="datatable__actions">
                <div className="datatable__actions__extras">
                    <Row className="flex--align-center">
                        <Col xs={6}>
                            {t(`docs.pagination.page`)}{" "}
                            <strong>
                                {pageIndex + 1} {t(`docs.pagination.of`)} {pageOptions.length === 0 ? pageOptions.length+1 : pageOptions.length}
                            </strong>
                        </Col>
                        <Col xs={6} className="a-right">
                            <CustomInput
                                type="select"
                                value={pageSize}
                                id="row-range-select"
                                onChange={onChangeInSelect}
                            >
                                {[10, 20, 30, 40, 50].map((pageSize) => (
                                    <option key={pageSize} value={pageSize}>
                                        {t(`docs.pagination.show`)} {pageSize}
                                    </option>
                                ))}
                            </CustomInput>
                        </Col>
                    </Row>
                </div>
                {(pageCount ?
                <div className="datatable__actions__base flex flex--justify-center">
                    <button
                        className="btn btn--table"
                        onClick={() => gotoPage(0)}
                        disabled={!canPreviousPage}
                    >
                        <i className="fas fa-angle-double-left"></i>
                    </button>
                    <button
                        className="btn btn--table"
                        onClick={previousPage}
                        disabled={!canPreviousPage}
                    >
                        <i className="fas fa-angle-left"></i>
                    </button>
                    <div>
                        <Input
                            type="number"
                            className="input-current-page"
                            min={1}
                            style={{ width: 70 }}
                            max={pageOptions.length}
                            value={pageIndex + 1}
                            onChange={onChangeInInput}
                        />
                    </div>
                    <button
                        className="btn btn--table"
                        onClick={nextPage}
                        disabled={!canNextPage}
                    >
                        <i className="fas fa-angle-right"></i>
                    </button>
                    <button
                        className="btn btn--table"
                        onClick={() => gotoPage(pageCount - 1)}
                        disabled={!canNextPage}
                    >
                        <i className="fas fa-angle-double-right"></i>
                    </button>
                </div>
                : null)}
            </div>
        </Aux>
    );
};

export default SubAccountsTable;
